import * as angular from "angular";

angular
  .module('bringoz.admin.webhooks')
  .config(WebhookConfig);

/* @ngInject */
function WebhookConfig($stateProvider) {

  $stateProvider

    // Webhooks
    .state('webhooks', {
      parent: 'bringoz.site',
      url: '/webhooks',
      controller: function() {
      },
      template: '<ui-view>'
    })

    // Webhooks Table
    .state('webhooks.table', {
      url: '/table',
      controllerAs: 'vm',
      template: '<webhooks-view></webhooks-view>',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Table"});
        triBreadcrumbsService.addCrumb({name: "Webhooks"});
      }
    })
}
